module.exports = __webpack_public_path__ + "img/img2.02a0ac68.png";